import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { STALE_QUERY_TIMEOUT_MSEC } from "./constants";

export function useEventMetadataKeys(
  orgId: string,
): UseQueryResult<string[], Error> {
  const { events } = useDomainServices();

  return useQuery({
    queryKey: ["orgEventMetadataKeys", orgId],
    queryFn: ({ signal }) => {
      return events.getMetadataKeysForOrg({
        abortSignal: signal,
        resourceOwnerId: orgId,
      });
    },
    staleTime: STALE_QUERY_TIMEOUT_MSEC,
  });
}
